import React, { useState, useEffect } from "react";
import Modal from "../UI/Modal";
import Button from "../UI/Button";
import { useDispatch, useSelector } from "react-redux";

import { popupActions } from "../../store/popup-slice";
import { bookingActions } from "../../store/booking-slice";

import classes from "./ReturningGuestPopup.module.css";
import CheckReturningGuest from "../ReturningGuestApi/CheckReturningGuest.js";

import Loader from "react-loader-spinner";

const ReturningGuestPopup = () => {
  const dispatch = useDispatch();

  const returningPopup = useSelector((state) => state.popup.returningPopup);
  const guestNumber = useSelector((state) => state.popup.guestNumber);

  const [email, setEmail] = useState("");
  const [emailIsValid, setEmailIsValid] = useState(false);
  const [emailShowError, setEmailShowError] = useState(false);

  const [guestIsReturning, setGuestIsReturning] = useState();
  const [emailAPICheck, setEmailAPICheck] = useState(false);

  const _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      ReturningSubmit();
    }
  };

  const checkValidEmail = (event) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    setEmailIsValid(re.test(String(event.target.value).toLowerCase()));
    setEmail(event.target.value);
    emailIsValid && setEmailShowError(!emailIsValid);
  };

  const onBlueEmail = () => {
    setEmailShowError(!emailIsValid);
  };

  const ReturningPopupHide = () => {
    dispatch(popupActions.setReturningPopupHide());
    setEmail("");
    setEmailIsValid(false);
    setEmailShowError(false);
    setGuestIsReturning();
  };

  const ReturningSubmit = () => {
    emailIsValid && returningSubmit();
    !emailIsValid && setEmailShowError(true);
  };

  const returningSubmit = () => {
    setEmailAPICheck(true);
  };

  useEffect(() => {
    if (guestIsReturning && !emailAPICheck) {
      guestNumber === 1
        ? dispatch(
            bookingActions.setGuest1Returning({
              guest1Returning: true,
              guest1ReturningEmail: email,
            })
          )
        : dispatch(
            bookingActions.setGuest2Returning({
              guest2Returning: true,
              guest2ReturningEmail: email,
            })
          );
      dispatch(popupActions.setReturningPopupHide());
      setEmail("");
      setEmailIsValid(false);
      setEmailShowError(false);
      setGuestIsReturning();
    }
  }, [guestIsReturning, emailAPICheck, guestNumber, dispatch, email]);

  return (
    returningPopup && (
      <Modal onClose={ReturningPopupHide}>
        <div>
          <h2>Welcome Back!</h2>

          <p>
            If you have previously cleansed at any of our Amity Wellness
            locations then you will automatically qualify for a special
            returning loyalty discount on any of our cleansing packages.
          </p>

          <p>
            Please enter the email address you used to book your previous stay
          </p>

          <div className={classes.controlGroup}>
            <div className={classes.formControl}>
              <input
                autoFocus
                value={email}
                type="email"
                className={`${classes.emailIcon} ${
                  emailIsValid ? classes.successIcon : ""
                } ${emailShowError ? classes.errorIcon : ""}`}
                placeholder="E-mail"
                id="email"
                onChange={checkValidEmail}
                onBlur={onBlueEmail}
                autoComplete="off"
                onKeyDown={_handleKeyDown}
              />
              {emailShowError && (
                <p className={classes.errorText}>
                  Please enter a valid e-mail address!
                </p>
              )}
              {guestIsReturning === false && (
                <p className={classes.errorText}>
                  Sorry this email address can not be found in our system.
                  Please email us at info@amitywellness.com for assistance.
                </p>
              )}
            </div>
          </div>

          <CheckReturningGuest
            email={email}
            guestNumber={guestNumber}
            setEmailAPICheck={setEmailAPICheck}
            emailAPICheck={emailAPICheck}
            setGuestIsReturning={setGuestIsReturning}
          />

          {emailAPICheck && (
            <div className={classes.spinnerContainer}>
              <Loader type="Rings" color="#00BFFF" height={80} width={80} />
            </div>
          )}

          <div className={classes.buttonContainerCancel}>
            <Button onClick={ReturningPopupHide} buttonText="Cancel" />
          </div>
          <div className={classes.buttonSpacer}></div>
          <div className={classes.buttonContainerSubmit}>
            <Button onClick={ReturningSubmit} buttonText="Apply" />
          </div>
        </div>
      </Modal>
    )
  );
};

export default ReturningGuestPopup;
